import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../apiClient";

export const postBusCourse = data => {
  return api.post(`/admin/bus-courses-v2`, data);
};

export const usePostBusCourseMutation = ({ mutationConfig } = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: postBusCourse,
    onSuccess: async (data, ...args) => {
      if (onSuccess) {
        await onSuccess(data, ...args);
      }
      queryClient.resetQueries();
    },
    ...restConfig,
  });
};
